import React from 'react';
import { CircularProgress, Typography, Box } from '@mui/material';
import { coresFigma } from './styles/colors';

const Loading = ({ message = null }) => {
    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            height="60vh"
        >
            <CircularProgress
                sx={{
                    color: '#3AAEAE',
                    marginBottom: 2,
                    animationDuration: '800ms' 
                }}
            />
            <Typography variant="h6" marginTop={2}>
                Carregando...
            </Typography>
            {message ? (
                <Typography
                    variant="body2"
                    sx={{
                        mt: 1,
                        color: '#667085',
                        textAlign: 'center',
                        maxWidth: 420
                    }}
                >
                    {message}
                </Typography>
            ) : null}           
        </Box>
    );
};

export default Loading;
